// /////////////
// マウントポイント
// /////////////
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import InteractForm from './InteractForm.vue'
import type { VueProps } from '@/entries/interact-form/types'

// グローバル変数からプロップを取得
const mountId = 'interact-form'
const props = window.vueProps && window.vueProps[mountId] ? window.vueProps[mountId] : {}

// プロップを渡してアプリケーションを作成
const app = createApp(InteractForm, props)
app.use(createPinia())
app.mount(`#${mountId}`) // WordPressテンプレート側のマウントポイントに対応
